var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g({ staticClass: "image" }, _vm.$listeners),
    [
      _c("no-ssr", [
        _c("img", {
          directives: [
            {
              name: "lazy",
              rawName: "v-lazy",
              value: {
                src: _vm.image,
                loading: "/assets/mstile-150x150.png",
                error: "/assets/mstile-150x150.png"
              },
              expression:
                "{src: image, loading: '/assets/mstile-150x150.png', error: '/assets/mstile-150x150.png'}"
            }
          ],
          key: "image",
          ref: "images",
          staticClass: "image__thumb",
          attrs: { alt: _vm.alt, itemprop: "image" }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }